export default "__VITE_ASSET__BK50VT2C__"